var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--text", style: _vm.messageColors },
    [
      [
        _c(
          "div",
          {
            staticClass: "sc-message--toolbox",
            style: { background: _vm.messageColors.backgroundColor }
          },
          [
            _vm.me && _vm.message.id != null && _vm.message.id != undefined
              ? _c(
                  "button",
                  {
                    attrs: { disabled: _vm.isEditing },
                    on: { click: _vm.edit }
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          color: _vm.isEditing
                            ? "black"
                            : _vm.messageColors.color,
                          width: "10",
                          "icon-name": "edit"
                        }
                      },
                      [_c("icon-edit")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.me && _vm.message.id != null && _vm.message.id != undefined
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$emit("remove")
                      }
                    }
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          color: _vm.messageColors.color,
                          width: "10",
                          "icon-name": "remove"
                        }
                      },
                      [_c("icon-cross")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("text-message-toolbox", null, {
              message: _vm.message,
              me: _vm.me
            })
          ],
          2
        )
      ],
      _vm._v(" "),
      _vm._t(
        "default",
        function() {
          return [
            _c("p", {
              staticClass: "sc-message--text-content",
              domProps: { innerHTML: _vm._s(_vm.messageText) }
            }),
            _vm._v(" "),
            _vm.message.data.meta
              ? _c(
                  "p",
                  {
                    staticClass: "sc-message--meta",
                    style: { color: _vm.messageColors.color }
                  },
                  [_vm._v(_vm._s(_vm.message.data.meta))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.message.isEdited
              ? _c(
                  "p",
                  { staticClass: "sc-message--edited" },
                  [
                    _c(
                      "icon-base",
                      { attrs: { width: "10", "icon-name": "edited" } },
                      [_c("icon-edit")],
                      1
                    ),
                    _vm._v(" edited\n    ")
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        {
          message: _vm.message,
          messageText: _vm.messageText,
          messageColors: _vm.messageColors,
          me: _vm.me
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc05db14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc05db14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/messages/TextMessage.vue
// module id = 1882
// module chunks = 117